import React from 'react';
import { ArrowRightIcon, CheckIcon, ClockIcon, LockIcon } from 'lucide-react';
import { bundle, checkoutUrl, ebookImage, price } from '../data/content';
export function Offer() {
  return <section id="oferta" className="bg-teal-deep text-white" data-id="element-134" data-mp="1mn91hlinz06n">
      <div className="mx-auto grid max-w-5xl gap-12 px-6 py-16 lg:grid-cols-[0.9fr_1.1fr] lg:items-center lg:py-24" data-id="element-135" data-mp="1mpli9vcor4i4">
        <img src={ebookImage} alt="Bundle completo del Método Vientre Plano 21D mostrado en una tablet" className="w-full rounded-[2rem] object-cover" loading="lazy" data-id="element-136" data-mp="tyv5tcf1sfy9" />

        <div data-id="element-137" data-mp="13xkce91hudz7">
          <h2 className="font-display text-3xl font-semibold leading-tight tracking-tight sm:text-4xl" data-id="element-138" data-mp="13xauz9uilf54">
            Obtén el Bundle Completo del Método Vientre Plano 21D hoy mismo
          </h2>
          <p className="mt-5 max-w-prose leading-relaxed text-white/80" data-id="element-139" data-mp="2fbeqikgr3bca">
            Todo lo que necesitas para resetear tu cuerpo y volver a sentirte
            cómoda en tu propia piel.
          </p>

          <ul className="mt-8 space-y-2.5" data-id="element-140" data-mp="pl0cxuyqtwee">
            {bundle.map(item => <li key={item.name} className="flex gap-3 text-sm leading-relaxed text-white/85" data-id="element-141" data-mp="uisgxncnx8yy">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-142" data-mp="ziwmiic18jae" />
                {item.name}
              </li>)}
          </ul>

          <div id="precio" className="mt-10 scroll-mt-16 rounded-2xl bg-white/10 p-6 ring-1 ring-white/15" data-id="element-143" data-mp="6rmswkwkjadk">
            <p className="text-xs font-semibold uppercase tracking-[0.16em] text-teal-soft" data-id="element-144" data-mp="fu5pwodoasrw">
              {price.label}
            </p>
            <div className="mt-2 flex flex-wrap items-baseline gap-x-3 gap-y-1" data-id="element-145" data-mp="kmfd3wneleqh">
              <p className="font-display text-4xl font-semibold" data-id="element-146" data-mp="3k7ui8k0brztp">
                {price.amount}{' '}
                <span className="text-lg font-medium text-white/70" data-id="element-147" data-mp="3o8wf4u6rrzsi">
                  {price.currency}
                </span>
              </p>
              <p className="text-lg text-white/50 line-through" data-id="element-148" data-mp="qgnrmgj4j4jp">
                {price.original}
              </p>
              <p className="rounded-full bg-gold px-2.5 py-1 text-xs font-semibold text-ink" data-id="element-149" data-mp="15620zomp9lz3">
                {price.discount} de descuento
              </p>
            </div>
            <a href={checkoutUrl} className="group mt-6 flex w-full items-center justify-center gap-2 rounded-full bg-gold px-6 py-4 text-center text-base font-semibold text-ink transition-colors duration-150 ease-smooth hover:bg-[#c69c58] focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-teal-deep" data-id="element-150" data-mp="108tj7p5grjyd">
              ¡Sí, quiero mi vientre plano ahora!
              <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 ease-smooth group-hover:translate-x-0.5" aria-hidden="true" data-id="element-151" data-mp="1wv55n5ii0yc9" />
            </a>
            <ul className="mt-5 flex flex-wrap gap-x-6 gap-y-2 text-xs text-white/70" data-id="element-152" data-mp="20d2p0s47y9sl">
              <li className="inline-flex items-center gap-2" data-id="element-153" data-mp="25ei7ccf0i27a">
                <ClockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-154" data-mp="1qgzlpixms542" />
                Acceso instantáneo después del pago
              </li>
              <li className="inline-flex items-center gap-2" data-id="element-155" data-mp="1vg2r54hiwdck">
                <LockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-156" data-mp="2j4lquvmibht1" />
                Oferta por tiempo limitado
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>;
}